// /js/common/marquee.js
export function initMarquee(scope = document) {
  const marquees = scope.querySelectorAll('.c-marquee');

  marquees.forEach((root) => {
    const track = root.querySelector('.c-marquee__track');
    const list = track.querySelector('.c-marquee__list');
    if (!list) return;

    // クローンを横に追加（track が flex なので横並びになる）
    const clone = list.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true'); // 読み上げ抑止（任意）
    track.appendChild(clone);

    // CSS変数
    track.style.setProperty('--mq-clone-length', '2'); // 2周分（元+クローン）
    track.style.setProperty('--mq-duration', '45s');   // 速度（長いほどゆっくり）
    track.style.setProperty('--marquee-gap', '0px');   // 余白不要なら 0

    // 方向
    track.dataset.direction = (root.dataset.direction === 'right') ? 'right' : 'left';

    // 準備完了
    track.dataset.state = 'ready';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initMarquee());
} else {
  initMarquee();
}
